import { createFileRoute, redirect } from '@tanstack/react-router'

import { DEFAULT_MASTRA_AGENT_ID } from '@/widgets/mastra-chat'

// Back-compat redirect: forward the old agent-less thread URL to the default ("General")
// agent, preserving the thread `uuid`.
export const Route = createFileRoute('/_app/agents/chat/$uuid')({
  beforeLoad: ({ params }) => {
    throw redirect({
      to: '/agents/$agentId/chat/$uuid',
      params: { agentId: DEFAULT_MASTRA_AGENT_ID, uuid: params.uuid },
      replace: true,
    })
  },
})
